/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */

'use strict';

var LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
  __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function suspenseSentinel() {
  // $FlowFixMe[incompatible-return]
  return LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function isSuspenseSentinel(value) {
  return value === LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
  isSuspenseSentinel: isSuspenseSentinel,
  suspenseSentinel: suspenseSentinel
};